import React from 'react';
import CustomInputField from '../../atoms/CustomInputField';
import CustomSelectBox from '../../atoms/CustomSelectBox';
import { HomeOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { UserOutlined, UserAddOutlined } from '@ant-design/icons';
import { Container, CustomInputLeft } from './style';

import { Row, Col, Select } from 'antd';

const { Option } = Select;

const SalesScreenLeftHeader = (props) => {
  const { warehouseList, handleWarehouse = () => {} } = props;

  return (
    <>
      <Row gutter={[16, 16]} align='middle'>
        {/* First Row: Two Input Groups Side by Side */}
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Input.Group compact style={{ display: 'flex' }}>
            <CustomInputField
              style={{
                width: '40px',
                height: '56px',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              prefix={<UserOutlined style={{ fontSize: '18px' }} />}
            />
            <CustomSelectBox
              showSearch
              style={{
                flex: 1,
                height: '56px',
                borderRadius: '26px',
              }}
              size='large'
              placeholder='Select a person'
              optionFilterProp='children'
              addonBefore='jklahsdk'
              filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
            >
              <Option value='jack'>Jack</Option>
              <Option value='lucy'>Lucy</Option>
              <Option value='tom'>Tom</Option>
            </CustomSelectBox>
            <CustomInputField
              style={{
                width: '46px',
                height: '56px',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#1677ff',
                color: 'white',
              }}
              prefix={<UserAddOutlined />}
            />
          </Input.Group>
        </Col>

        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <Input.Group compact style={{ display: 'flex' }}>
            <Input
              style={{
                width: '46px',
                height: '56px',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              prefix={<HomeOutlined style={{ fontSize: '18px' }} />}
            />
            <CustomSelectBox
              size='large'
              showSearch
              placeholder='Select a warehouse'
              onChange={handleWarehouse}
              options={warehouseList}
              style={{
                flex: 1,
                height: '56px',
                borderRadius: '26px',
              }}
            />
          </Input.Group>
        </Col>
      </Row>
    </>
  );
};

export default SalesScreenLeftHeader;
